const financeTypes = {
	if: 'InterestFree',
	bnpl: 'BuyNowPayLater',
};

export const getFinanceData = (imageName, price) => {
	if (typeof imageName !== 'string') {
		return null;
	}

	const duration = imageName.match(/\d+/);

	return {
		type:
			financeTypes[
				Object.keys(financeTypes).filter((item) => imageName.includes(item))[0]
			],
		duration: duration ? duration[0] : null,
		monthlyPrice:
			duration && price
				? (Math.ceil((price / duration[0]) * 100) / 100).toFixed(2)
				: null,
	};
};
